import type { DocData, DocSnapshot } from '../types';
import { doc, onSnapshot } from 'firebase/firestore';
import firestore from './firestore';
import { readDocumentSnapshot } from './firestoreData';
import logger from './logger';

export default async function subscribeToFirebaseDoc<T extends DocData>(
  key: string,
  receiver: (data: { snapshot: DocSnapshot<T>; data: T | undefined }) => void,
) {
  return new Promise<() => void>((resolve, reject) => {
    logger.debug({ key }, 'subscribeToFirebaseDoc');
    const unsubscribe = onSnapshot(
      doc(firestore, key),
      (snapshot) => {
        receiver({
          snapshot: snapshot as DocSnapshot<T>,
          data: readDocumentSnapshot<T>(snapshot),
        });

        resolve(unsubscribe);
      },
      (err) => {
        reject(err);
      },
    );
  });
}
